// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reports-filters .filters-panel{height:calc(100vh - 255px);max-height:600px;width:450px;top:44px}", ""]);
// Exports
module.exports = exports;
